export default "__VITE_ASSET__BpUznDv9__"